import React from 'react';
import '../styles/Footer.css'; // You will style the Footer here

const icons = {
    discord: require('../Assets/Website Pack/Logo/Discord.png'),
    twitter: require('../Assets/Website Pack/Logo/Twitter.png'),
    youtube: require('../Assets/Website Pack/Logo/YouTube.png'),
    bluesky: require('../Assets/Website Pack/Logo/Bluesky.png'),
    reddit: require('../Assets/Website Pack/Logo/Reddit.png'),
}
const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-icons">
                <a href="https://discord.com/invite/C9SkYT8BrP" target="_blank" rel="noopener noreferrer">
                    <img src={icons.discord} alt="Discord" className="footer-icon"/>
                </a>
                <a href="https://x.com/5thstepgames" target="_blank" rel="noopener noreferrer">
                    <img src={icons.twitter} alt="Twitter" className="footer-icon"/>
                </a>
                <a href="https://youtube.com/@polybeatsgame" target="_blank" rel="noopener noreferrer">
                    <img src={icons.youtube} alt="YouTube" className="footer-icon"/>
                </a>
                <a href="https://www.reddit.com/r/PolyBeats/" target="_blank" rel="noopener noreferrer">
                    <img src={icons.reddit} alt="Reddit" className="footer-icon"/>
                </a>
                <a href="https://bsky.app/profile/5thstepgames.co.uk" target="_blank" rel="noopener noreferrer">
                    <img src={icons.bluesky} alt="Bluesky" className="footer-icon"/>
                </a>
            </div>
        </div>
    );
};

export default Footer;
